module.exports = __webpack_public_path__ + "static/media/casa.c4e25fc8.png";